import { Badge, Image } from '@chakra-ui/react';
import playStoreBadge from '../assets/playStoreBadge.png';

const PlayStoreBadge = () => (
  <Badge colorScheme="purple">
    <Image
      src={playStoreBadge}
      alt="Play Store"
      width={32}
      borderRadius="x1"
    />{' '}
  </Badge>
);

export default PlayStoreBadge;
